import { render } from "./AccountInfoDropdown.vue?vue&type=template&id=391bb8e8&scoped=true"
import script from "./AccountInfoDropdown.vue?vue&type=script&lang=js"
export * from "./AccountInfoDropdown.vue?vue&type=script&lang=js"

import "./AccountInfoDropdown.vue?vue&type=style&index=0&id=391bb8e8&scoped=true&lang=css"

import exportComponent from "/home/vsts/work/1/s/solution/web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-391bb8e8"]])

export default __exports__